import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Campaign, CampaignDelay } from "../models/Campaign";
import { HeatMechanicalResult } from "../models/HeatMechanicalResult";
import { MechanicalTestRunDisposition } from "../models/MechanicalTestRunDisposition";

const moment = getMomentTz();

// [FAB].[GetMillHeatList]: RS0 = delay totals per campaign, RS1 = campaigns
// (mill SP last — its result-set count drifts, any tail is ignored)
export const getMillHeatList = async (
	params: { start?: Date | null; end?: Date | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];
	if (params.start)
		parameters.push({ name: "Start", value: params.start.toISOString() });
	if (params.end)
		parameters.push({ name: "End", value: params.end.toISOString() });

	const resp = await apiService.callV2(
		"[FAB].[GetMillHeatList]",
		parameters,
		signal,
	);

	if (!resp.ok) throw new Error(resp.message || "Error fetching heat list");

	const delays = get(resp, "data.tables[0].rows", []) as CampaignDelay[];

	const campaignRows = get(resp, "data.tables[1].rows", []);
	const campaigns = campaignRows.map((campaign: Campaign) => ({
		...campaign,
		Start: campaign.Start ? moment.utc(campaign.Start).toDate() : null,
		End: campaign.End ? moment.utc(campaign.End).toDate() : null,
		SampleStatusTimestamp: campaign.SampleStatusTimestamp
			? moment.utc(campaign.SampleStatusTimestamp).toDate()
			: null,
	})) as Campaign[];

	return { campaigns, delays };
};

// [FAB].[GetMillHeatResults]: RS0 = dispositions, RS1 = mechanical results
// (mill SP last — its result-set count drifts, any tail is ignored)
export const getMillHeatResults = async (
	params: { heatId: number },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "HeatId", value: params.heatId }];

	const resp = await apiService.callV2(
		"[FAB].[GetMillHeatResults]",
		parameters,
		signal,
	);

	if (!resp.ok) throw new Error(resp.message || "Error fetching heat results");

	const dispositionRows = get(resp, "data.tables[0].rows", []);
	const dispositions = dispositionRows.map(
		(row: MechanicalTestRunDisposition) => ({
			...row,
			DisposedAt: row.DisposedAt ? moment.utc(row.DisposedAt).toDate() : null,
			Reception: row.Reception ? moment.utc(row.Reception).toDate() : null,
			Reported: row.Reported ? moment.utc(row.Reported).toDate() : null,
		}),
	) as MechanicalTestRunDisposition[];

	const resultRows = get(resp, "data.tables[1].rows", []);
	const results = resultRows.map((row: HeatMechanicalResult) => ({
		...row,
		Reception: row.Reception ? moment.utc(row.Reception).toDate() : null,
		Reported: row.Reported ? moment.utc(row.Reported).toDate() : null,
	})) as HeatMechanicalResult[];

	return { results, dispositions };
};
